'use es6';

export const feedbackClientSelector = state => state.getIn(['feedbackClient', 'client']);
export const feedbackContactSelector = state => state.getIn(['feedbackClient', 'contact']);
export const VISIBLE_SURVEYS_EVAL_MAP = {};